import { format, parseISO } from 'date-fns';
import { enGB, it } from 'date-fns/locale';

const locales = { enGB, it };

export const isToday = (d: Date) => {
  const today = new Date();
  return (
    d.getDate() === today.getDate() && d.getMonth() === today.getMonth() && d.getFullYear() === today.getFullYear()
  );
};

export const getDateAsISOString = (date: any) => {
  if (date && date instanceof Date) {
    return date.toISOString();
  }
};

export const formatDate = (date: string | undefined | null) => {
  return date ? format(parseISO(date), 'dd/MM/yyyy') : '';
};

export const getDateFnsLocaleFromLang = (lang = 'it'): Locale => {
  let langFixed = lang;
  let temp = lang.split('-');

  if (temp.length > 1) {
    langFixed = temp[0];
  }
  if (langFixed === 'en') {
    langFixed = 'enGB';
  }
  return locales[langFixed as keyof typeof locales];
};

export const getTranslatedStringFromDate = (date: any, lang: string) => {
  if (date && date instanceof Date) {
    return format(date, 'd LLL', { locale: getDateFnsLocaleFromLang(lang) });
  }
};
